// extracted by mini-css-extract-plugin
export default {"tutorialBG":"TutorialStyles_tutorialBG__QhCMd","show":"TutorialStyles_show__DJMlS","tutorial":"TutorialStyles_tutorial__r-qsA","skipCount":"TutorialStyles_skipCount__V1Gf7"};